import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import Mapdialog from './mapdialog';
import ExploreIcon from '@material-ui/icons/Explore';
import { Impressaoviagem } from '../util/Impressaoviagem';
import { Impressaointerno } from '../util/Impressaointerno';

import CallSplitIcon from '@material-ui/icons/CallSplit';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';//deferidas
import PinDropIcon from '@material-ui/icons/PinDrop';
import EventNoteIcon from '@material-ui/icons/EventNote';//analise
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { deepOrange, green } from '@material-ui/core/colors';
import CallMissedOutgoingIcon from '@material-ui/icons/CallMissedOutgoing';
import Tooltip from '@material-ui/core/Tooltip';
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';
import Grid from '@material-ui/core/Grid';
import Cardselectmotora from './cardselectmotoraecia';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { dateTimePickerDefaultProps } from '@material-ui/pickers/constants/prop-types';
import { DateTimePicker } from '@material-ui/pickers';
import Cardmap from './apmap';
import DialogChecklist from './dialogChecklist';
import { ControlPointDuplicateOutlined } from '@material-ui/icons';
import Link from '@material-ui/core/Link';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Localizadesvio from './Localizadesvio';
import ReportIcon from '@material-ui/icons/Report';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Badge from '@material-ui/core/Badge';
import { Impressaootdeferido } from '../util/Impressaootdeferido';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { Impressao } from '../util/Impressao';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    alignContent:'LEFT',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  datas:{
    alignItems: 'center',
    marginTop: theme.spacing(2),

  },
  rounded: {
    color: green[500],
    //backgroundColor: green[500],
  },
  rounded2: {
    color: red[500],
    //backgroundColor: green[500],
  },
  rounded3: {
    color: green[500],
    //backgroundColor: green[500],
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

//****************************************************************carregar tipos veiculo***************** */


     
 export default function RecipeReviewCard(props) {

//***************************** */
var custos = [];
var marcacao = [];
var ocorre = [];
var db3 = firebase.firestore();


//** */
var query = db3.collection("agenda").doc(props.props[0].id).collection("marcacoes").orderBy('datahora').get()
.then(function(querySnapshot) {
querySnapshot.forEach(function(doc) {


marcacao.push({marcacao: doc.data().marcacao, datahora:new Date(doc.data().datahora.seconds*1000).toLocaleString("pt-BR")})
        
console.log(marcacao)


})


}).catch(error => {
console.log(error);
});

//****************** */
var db7 = firebase.firestore();
   var query2 =  db7.collection("agenda").doc(props.props[0].id).collection("ocorrencias").get()
   .then(function(querySnapshot) {
     
     querySnapshot.forEach(function(doc) {
       
        
       ocorre.push({nomeassina:doc.data().nomeassina, ocorrencia: doc.data().ocorrencia, datahora:new Date(doc.data().datahora.seconds*1000).toLocaleString("pt-BR")})
                 
       
      
   
 })
 
 
 })
 
 
 
 
 
 .catch(error => {
    console.log(error);
 });

  //****************************visualiza ordem */
const visualizarordem = () => {
  console.log(props);
//var rel = Impressaosolicitacao(props)
  //pdfMake.createPdf(Impressaosolicitacao).open({}, window.open('', '_blank'));
  //rel.criarpdf();
  
    const classeImpressaoot = new Impressaootdeferido(props,marcacao);
    const documentoot = classeImpressaoot.GerarDocumento();
    pdfMake.createPdf(documentoot).open({}, window.open('', '_blank'));
  
  
  
}

//****************** */
const visualizarsolicitacao = () => {
  console.log(props);
//var rel = Impressaosolicitacao(props)
  //pdfMake.createPdf(Impressaosolicitacao).open({}, window.open('', '_blank'));
  //rel.criarpdf();
  if(props.props[0].tipodeslocamento==2){
    const classeImpressaov = new Impressaoviagem(props);
    const documentov = classeImpressaov.GerarDocumento();
    pdfMake.createPdf(documentov).open({}, window.open('', '_blank'));
  }else{
    if(props.props[0].tipodeslocamento==1){
      const classeImpressao = new Impressaointerno(props);
      const documento = classeImpressao.GerarDocumento();
      pdfMake.createPdf(documento).open({}, window.open('', '_blank'));
    }
  }
  
}

//**************** */
  
  const visualizardiario = () => {
        //******************* */
   
        var pagomotora=  parseFloat(stcafepago) + 
        parseFloat(stalmocopago) +
        parseFloat(stjantapago) +
        parseFloat(stpernoitepago);
        //var rel = Impressaosolicitacao(props)
        //pdfMake.createPdf(Impressaosolicitacao).open({}, window.open('', '_blank'));
        //rel.criarpdf();
    
        const classeImpressao = new Impressao(props, marcacao, ocorre, sthora100,stminuto100, sthora50,stminuto50, stadicionalnhora,stadicionalnminuto, stcafe, stalmoco, stjanta, stpernoite, pagomotora);
        const documento = classeImpressao.GerarDocumento();
    pdfMake.createPdf(documento).open({}, window.open('', '_blank'));
  }

  const[stid, setaid]=React.useState('');
  const[datahoraretorno, setadatahoraretorno]=React.useState('');
  const[dataretornoreal, setadataretornoreal]=React.useState();
  const[datahorasaida, setadatahorasaida]=React.useState('');
  const[datahorasaidareal, setadatahorasaidareal]=React.useState('');
  const[depsolicitente, setadepsolicitante]=React.useState('');
  const[dsolicitacao, setadsolicitacao]=React.useState('');
  const[nomesolicitante, setanomesolicitante]=React.useState('');
  const[lotacaosolicitante, setalotacaosolicitante]=React.useState('');
  const[telefonesolicitante, setatelefonesolicitante]=React.useState('');
  const[objetivo, setaobjetivo]=React.useState('');
  const[nsolicitacao, setansolicitacao]=React.useState('');
  const[npassageiro, setanpassageiro]=React.useState('');
  const[siapesolicitente, setasiapesolicitente]=React.useState('');
  const[listaparadasvolta, setalistaparadasvolta]=React.useState(['']);
  const[listaparadasida, setalistaparadasida]=React.useState(['']);
  const[listapassageiros, setalistapassageiros]=React.useState(['']);
  const[localdestino, setalocaldestino]=React.useState('');
    const[localsaida, setalocalsaida]=React.useState('');
    const[localdestinomapa, setalocaldestinomapa]=React.useState(['']);
  const[localsaidamapa, setalocalsaidamapa]=React.useState(['']);
  const[geolocalsaidamapa, setageolocalsaidamapa]=React.useState(['']);
  const[temporetorno, setatretorno]=React.useState('');
  const[geolocaldestinomapa, setageolocaldestinomapa]=React.useState(['']);
  const[campisolicitante, setacampisolicitante]=React.useState('');
  const[observacao, setaobservacao]=React.useState('');
  //const[anexos, setaanexos]=React.useState('');
  const[autorizacoes, setaautorizacoes]=React.useState([]);
  const[tipodeslocamento, setatipodeslocamento]=React.useState('');
  const[tipodesl, setatipodesl]=React.useState(0);
  const[nomerespdespesas, setanomerespdespesas]=React.useState('');
  const[fonerespdespesas, setafonerespdespesas]=React.useState('');
  const[stdivdespesas, setastdivdespesas]=React.useState(true);
  const[stdivcontroles, setastdivcontroles]=React.useState(true);
  const[stbttransferir, setastbttransferir]=React.useState(true);
  const[stbtdeferirmento, setastbtdeferirmento]=React.useState(false);
  const[stbtindeferirmento, setastbtindeferirmento]=React.useState(true);
  const[unidadetransferencia, setaunidadetransferencia]=React.useState('');
  const[kilometragem, setakilometragem]=React.useState('');
  const[passageiros, setapassageiros]=React.useState('');
  const[anexo, setaanexo]=React.useState([]);
  const[rdespesas, setardespesas]=React.useState(1);
  const[stsalvadespesas, setasalvadespesas]=React.useState(true);
  const[streturn, setareturn]=React.useState(true);
  const[stbotoes, setastbotoes]=React.useState(true);
  const[valorkm, setavalorkm]=React.useState('');
 
 
//********************objeto veiculo******************* */

const [itemagenda, setitemagenda] = React.useState([]);

var tipodesloc;
var respdesp;
var pagina;
React.useEffect(()=>{
  setitemagenda(props.props);
  console.log("item agend props ", props.props)
},[props])

React.useEffect(() => {
  console.log("item agend props ", props.usertipo)
  
  if((props.usertipo==6)||(props.usertipo==7)||(props.usertipo==8)||(props.usertipo==9)||(props.usertipo==10)){
    console.log(props.props[0].id); 
    console.log(props.props[0].nsolicitacao); 

    var db = firebase.firestore();
      var query = db.collection("agenda").doc(props.props[0].id).collection("despesas").doc(props.props[0].nsolicitacao).get()
        .then((doc) => {
          if (doc.exists) {
            var vtfatura=doc.data().valortotalfaturado;
           setavalortotalfaturado(vtfatura);
           setavalortotalpago(doc.data().valortotalpago);

            setahora100(doc.data().hora100);
            setastminuto100(doc.data().minuto100);
            setahora100pago(doc.data().valorpagohora100);
            setahora100faturado(doc.data().valorfaturadohora100);

            setahora50(doc.data().hora50);
            setaminuto50(doc.data().minuto50);
            setahora50pago(doc.data().valorpagohora50);
            setahora50faturado(doc.data().valorfaturadohora50);

            setaadicionalnhora(doc.data().adicionalnhora);
            setastadicionalnminuto(doc.data().adicionalnminuto);
            setastadicionalnhorapago(doc.data().valorpagoadicionaln);
            var adnf=doc.data().valorfaturadoadicionaln;
            setastadicionalnhorafaturado(adnf);

            setaesperahora(doc.data().esperahora);
            setastesperaminuto(doc.data().esperaminuto);
            setastesperahorapago(doc.data().valorpagoespera);
            setastesperahorafaturado(doc.data().valorfaturadoespera);


            setasobreavisohora(doc.data().sobreavisohora);
            setastsobreavisominuto(doc.data().sobreavisominuto);
            setastsobreavisohorapago(doc.data().valorpagosobreaviso);
            setastsobreavisohorafaturado(doc.data().valorfaturadosobreaviso);

            setacafe(doc.data().cafe);
            setastcafepago(doc.data().valorpagocafe);
            setastcafefaturado(doc.data().valorfaturadocafe);

            setaalmoco(doc.data().almoco);
            setastalmocopago(doc.data().valorpagoalmoco);
            setastalmocofaturado(doc.data().valorfaturadoalmoco);

            setajanta(doc.data().janta);
            setastjantapago(doc.data().valorpagojanta);
            setastjantafaturado(doc.data().valorfaturadojanta);

            setabanho(doc.data().banho);
            setastbanhopago(doc.data().valorpagobanho);
            setastbanhofaturado(doc.data().valorfaturadobanho);

            setapernoite(doc.data().pernoite)
            setastpernoitepago(doc.data().valorpagopernoite);
            setastpernoitefaturado(doc.data().valorfaturadopernoite);


          }
        })





        .catch(error => {
          console.log(error);
        });
    
    if(props.usertipo==10){
        setastbotoes(false);
        setasalvadespesas(false);
     }else{
        if((props.usertipo==6)||(props.usertipo==7)||(props.usertipo==8)||(props.usertipo==9)){
            setastbotoes(false);
            setareturn(false);
         } 
     }
    }







var dt='';
var datar='' ;
itemagenda.forEach(modelo=>(dt=modelo.datahoraretorno));
console.log("Documentuswss data updated!", dt);
if (dt!=undefined) {
  setadataretornoreal(dt);
  datar= new Date(dt.seconds*1000).toLocaleString("pt-BR");
  console.log("Documentuswss data updated!", datar);
  console.log("Document data updated!", datar);
}
//
var id='';
itemagenda.forEach(modelo=>(id=modelo.id));
setaid(id);

setadatahoraretorno(datar);
var dts='';
var datas=''
itemagenda.forEach(modelo=>(dts=modelo.datahorasaida));
if (dts!=undefined) {
  setadatahorasaidareal(dts);
  datas= new Date(dts.seconds*1000).toLocaleString("pt-BR");
  
}
setadatahorasaida(datas);
var depsol;
itemagenda.forEach(modelo=>(depsol=modelo.depsolicitacao));
console.log('valor do stateauco ',depsol);
if(depsol!=undefined){
  console.log('valor do stateauco ',depsol[0].nomedepsol);
setadepsolicitante(depsol[0].nomedepsol);
}

itemagenda.forEach(modelo=>(tipodesloc=modelo.tipodeslocamento));
console.log('valor do stateauco ',tipodesloc);
setatipodesl(tipodesloc)
if(tipodesloc==1){
  setatipodeslocamento('Deslocamento Interno')
}else{
  if(tipodesloc==2){
    setatipodeslocamento('Viagem')
   
itemagenda.forEach(modelo=>(respdesp=modelo.respdespesas));
console.log('responsavel' ,respdesp);
if((respdesp!='')||(respdesp!=undefined)){
  setardespesas(respdesp)
}
    var nomerespdesp;
itemagenda.forEach(modelo=>(nomerespdesp=modelo.nomerespdespesas));
setanomerespdespesas(nomerespdesp);
var fonerespdep;
itemagenda.forEach(modelo=>(fonerespdep=modelo.fonerespdespesas));
setafonerespdespesas(fonerespdep);
setastdivdespesas(false);
  }
}

var vkm ='';
itemagenda.forEach(modelo=>(vkm=modelo.valorkmrodado))
//alert (vkm);
setavalorkmrodado(vkm);

var km ='';
itemagenda.forEach(modelo=>(km=modelo.totalkm))
setakilometragem(km);

var ps ='';
var pss='';
itemagenda.forEach(modelo=>(ps=modelo.listapassageiros))
for (let index = 0; index < ps.length; index++) {
  pss = pss  + ps[index].passageiro.nome + ', ';
  console.log("psssss " + ps[index])
  console.log("psssss " , pss)
}
setapassageiros(pss);



var dsol ='';
itemagenda.forEach(modelo=>(dsol=modelo.dsolicitacao))
setadsolicitacao(dsol);
var nomesol=';'
itemagenda.forEach(modelo=>(nomesol=modelo.nomesolicitante))
setanomesolicitante(nomesol);
var cp ='';
itemagenda.forEach(modelo=>(cp=modelo.campisolicitante))
setacampisolicitante(cp);
var telsol = '';
itemagenda.forEach(modelo=>(telsol=modelo.telefonesolicitante))
setatelefonesolicitante(telsol);
var obj = '';
itemagenda.forEach(modelo=>(obj=modelo.objetivo))
setaobjetivo(obj);
var nsol = '';
itemagenda.forEach(modelo=>(nsol=modelo.nsolicitacao))
//setlot(lota);
setansolicitacao(nsol);
var np='';
itemagenda.forEach(modelo=>(np=modelo.npassageiro))
setanpassageiro(np);
var siapesol='';
itemagenda.forEach(modelo=>(siapesol=modelo.siapesolicitente))
setasiapesolicitente(siapesol);
var obs = '';
itemagenda.forEach(modelo=>(obs=modelo.observacao))
setaobservacao(obs);

var vk='';
itemagenda.forEach(modelo=>(vk=modelo.valorkm));
setavalorkm(vk);

var aut = '';

itemagenda.forEach(modelo=>(aut=modelo.autorizacoes));
console.log("autorizacoes ",aut)
if((aut!=undefined)&&(aut!='')){
  setaautorizacoes(aut);
}


/*
itemagenda.forEach(modelo=>(listaparadas=modelo.listaparadas))
//setlot(lota);
itemagenda.forEach(modelo=>(listapassageiros=modelo.listapassageiros))
//setlot(lota);
*/
var dest='';
itemagenda.forEach(modelo=>(dest=modelo.localdestino))
setalocaldestinomapa(dest);
setalocaldestino(dest.description);
console.log('destino', localdestino )
var saida='';
itemagenda.forEach(modelo=>(saida=modelo.localsaida));
setalocalsaidamapa(saida);
setalocalsaida(saida.description);

var pida='';
itemagenda.forEach(modelo=>(pida=modelo.listaparadasida));
if((pida!='')&&(pida!=null)&&(pida!=undefined)){
  setalistaparadasida(pida);
}
//setalistaparadasida(pida);
var volta='';
itemagenda.forEach(modelo=>(volta=modelo.listaparadasvolta));
setalistaparadasvolta(volta);

var ane='';
itemagenda.forEach(modelo=>(ane=modelo.anexo));
if((ane!='')&&(ane!=undefined)){
  console.log("arquivo ", ane)
  const storageRef = firebase.storage().ref();
  const storageRefChild = storageRef.child('anexosagenda/' + id + '/' + ane);
  console.log("arquivo ", storageRefChild.name);
  //console.log("arquivo ", input)

  storageRefChild.getDownloadURL().then(function (url) { 
    // O url de serviço pode ser inserido em um <img> 
    //var img = document.getElementById ('muimui'); 
    console.log("arquivo ", url)
    //var img = url;
    setaanexo([{nome: ane, link: url}])
   // var link_item = document.getElementById('download-link')
   // link_item.setAttribute('href', url)
   // alert('uri anexo', img); 

  }) 
  .catch (function (err) { 
    console.log('Anexado'); 
  })


}


 
  var m='';
  itemagenda.forEach(modelo=>(m=modelo.motorista));
  setamotorista(m);
  if((m!='')&&(m!=undefined)){
    setavermotorista(m.label);
  }
  var v='';
  itemagenda.forEach(modelo=>(v=modelo.veiculo));
  setaveiculo(v);
  if((v!='')&&(v!=undefined)){
    setaverveiculo(v.label);
  }

},[itemagenda]);

//**********************************pegar anexos */



//*********************///*/
const[stbtdeferi, setastbtdeferi]=React.useState(false);
const[stbtindeferi, setastbtindeferi]=React.useState(false);
const[stbtsalvartranferencia, setastbtsalvartransferencia]=React.useState(true);
const[stbttrans, setastbttrans]=React.useState(false);
const[stdivtrans, setastdivtrans]=React.useState(true);
const[stdivtreferido, setastdivtreferido]=React.useState(true);
const[stdivmotora, setastdivmotora]=React.useState(true);
const[stbtreturn, setastbtreturn]=React.useState(true);
const[stbtencerrar, setastbtencerrar]=React.useState(true);
const[kmtotal, setakm]=React.useState();
const[vermotorista, setavermotorista]=React.useState('');
const[verveiculo, setaverveiculo]=React.useState('');







var listaassina 


const handleassina=()=>{

  console.log("Document autorizacao aqui!", autorizacoes);
  var unit = firebase.firestore().collection("agenda").doc(stid);
  return unit.update({autorizacoes: listaassina})
.then(() => {
  console.log("Document autorizacao updated!");
})
.catch((error) => {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
});
}

const handleencerrar =()=>{

  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'Encerrou'

  }
  
  
  setaautorizacoes(currentArray => [...currentArray, assina]);
  listaassina = autorizacoes;
  listaassina.push(assina);
  console.log("Document autorizacao updated!", listaassina);
    if((props.usertipo==7)||(props.usertipo==6)||(props.usertipo==8)||(props.usertipo==9)){

    //var data = new firebase.firestore.Timestamp(datahoraretorno);
    //var data = new Date(datahoraretorno.seconds*1000).toLocaleString("pt-BR");
    //console.log("Document data updated!", data);
    //console.log("Document data updated!", data);
    var unit = firebase.firestore().collection("agenda").doc(stid);
   // return unit.update({dataretornotimestamp:firebase.firestore.Timestamp.fromDate(new Date(datahoraretorno)),
     // datasaidatimestamp:firebase.firestore.Timestamp.fromDate(new Date(datahorasaida))})
    return unit.update({statusadm:'encerrado'})
   
  .then(() => {
    console.log("Document successfully updated!");
    setastbtencerrar(true);
    handleassina();
    alert("Solicitação Encerrada");
  })
  .catch((error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
  });
  
   }else{
      if(props.usertipo==10){
        var unit = firebase.firestore().collection("agenda").doc(stid);
      return unit.update({statusadm:'unidadetransporte'})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtencerrar(true);
      handleassina();
      alert("Solicitação Enviada para unidade de Transporte");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    }
  }

  






const [stunidadetransfere,setaunidadetrans]=React.useState([{}]);



const handleretornarsupervisão=()=>{

  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'Retornou para supervisão'

  }
  
  
  setaautorizacoes(currentArray => [...currentArray, assina]);
  listaassina = autorizacoes;
  listaassina.push(assina);
  console.log("Document autorizacao updated!", listaassina);
  
  
        var unit = firebase.firestore().collection("agenda").doc(stid);
      return unit.update({statusadm:'supervisao'})
    .then(() => {
      console.log("Document successfully updated!");
      setastbtreturn(true);
      handleassina();
      alert("Solicitação enviada para revisão");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });
    //************************ */


}

const [motorista, setamotorista]=React.useState([{
  id:'', label:''
}]);
const [veiculo, setaveiculo]=React.useState([{
  id:'', label:''
}]);





//const [stveiculo,setaveiculo]=React.useState();
const setatemporetorno=(props)=>{
  var hretorno = new Date();//dataretornoreal;
  var hretorno= new Date(dataretornoreal.seconds*1000);//.toLocaleString("pt-BR");
 // alert (dataretornoreal);

  var atraso = props+300;

  hretorno.setSeconds(hretorno.getSeconds() + atraso);
  setatretorno(hretorno.toLocaleString("pt-BR"))
  //setadataretornoreal(hretorno)
  //alert (hretorno);
}


const [stvalorkmrodado,setavalorkmrodado]=React.useState();


const [stlotamotora,setastlotamotora]=React.useState();




      
                    //********************************** */

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const [condicao, setacondicao] = React.useState([]);
  const handleExpandClick = () => {
    setExpanded(!expanded);
    if(expanded){
    
  }};

  //*******************************checklist***************** */

  const [opendchecklist, setopendchecklist] = React.useState(false);

  const handleClickopendchecklist = () => {
    if((props.usertipo==6)||(props.usertipo==7)||(props.usertipo==8)||(props.usertipo==9)||(props.usertipo==10)){
      console.log(props.props[0].id); 
      console.log(props.props[0].nsolicitacao); 
      var db2 = firebase.firestore();
      var query =  db2.collection("agenda").doc(props.props[0].id).collection("checklist").get()
      .then(function(querySnapshot) {
       querySnapshot.forEach(function(doc) {
                     
                    setamotoretc( doc.data().stmotoretc); 
                    setarelmotor(doc.data().relmotor);
                    setapneu(doc.data().stpneu);
                    setarelpneu(doc.data().relpneu);
                    setasinal(doc.data().stsinal);
                    setarelsinal(doc.data().relsinal);
                    setamacaco(doc.data().stmacaco);
                    setarelmacaco(doc.data().relmacaco);
                    setar(doc.data().star);
                    setarelar(doc.data().relar);
                    setaextintor(doc.data().stextintor);
                    setarelextintor(doc.data().relextintor);
                    setacinto(doc.data().stcinto)
                    setarelcinto(doc.data().relcinto);
                    setavel(doc.data().stvel);
                    setarelvel(doc.data().relvel);
                    setalaudo(doc.data().stlaudo);
                    setarellaudo(doc.data().rellaudo);
                    setalimpa(doc.data().stlimpa);
                    setarellimpa(doc.data().rellimpa);
                    setarelobs(doc.data().relobs);
    
      
    })
    setopendchecklist(true);
    })
    
    
    
    
    
    .catch(error => {
       console.log(error);
    });
    
    
    
    }
    
  };
  
    const handleClosedopendchecklist = () => {
      setopendchecklist(false);
    };

    //**************************** */
    const[stmotoretc, setamotoretc]=React.useState('1');
    const [relmotor, setarelmotor]=React.useState('');
    const handlemotoretc=(event)=>{
      setamotoretc(event.target.value);
    }
    //**************************** */

      //**************************** */
      const[stpneu, setapneu]=React.useState('1');
      const [relpneu, setarelpneu]=React.useState('');
      const handlepneu=(event)=>{
        setapneu(event.target.value);
      }
      //**************************** */

       //**************************** */
       const[stsinal, setasinal]=React.useState('1');
       const [relsinal, setarelsinal]=React.useState('');
       const handlesinal=(event)=>{
         setasinal(event.target.value);
       }
       //**************************** */

        //**************************** */
        const[stmacaco, setamacaco]=React.useState('1');
        const [relmacaco, setarelmacaco]=React.useState('');
        const handlemacaco=(event)=>{
          setamacaco(event.target.value);
        }
        //**************************** */

        
        //**************************** */
        const[star, setar]=React.useState('1');
        const [relar, setarelar]=React.useState('');
        const handlear=(event)=>{
          setar(event.target.value);
        }
        //**************************** */

         //**************************** */
         const[stextintor, setaextintor]=React.useState('1');
         const [relextintor, setarelextintor]=React.useState('');
         const handleextintor=(event)=>{
           setaextintor(event.target.value);
         }
         //**************************** */

         //**************************** */
         const[stcinto, setacinto]=React.useState('1');
         const [relcinto, setarelcinto]=React.useState('');
         const handlecinto=(event)=>{
           setacinto(event.target.value);
         }
         //**************************** */

         //**************************** */
         const[stvel, setavel]=React.useState('1');
         const [relvel, setarelvel]=React.useState('');
         const handlevel=(event)=>{
           setavel(event.target.value);
         }
         //**************************** */

         //**************************** */
         const[stlaudo, setalaudo]=React.useState('1');
         const [rellaudo, setarellaudo]=React.useState('');
         const handlelaudo=(event)=>{
           setalaudo(event.target.value);
         }
         //**************************** */

         //**************************** */
         const[stlimpa, setalimpa]=React.useState('1');
         const [rellimpa, setarellimpa]=React.useState('');
         const handlelimpa=(event)=>{
           setalimpa(event.target.value);
         }
         //**************************** */

         //**************************** */
         const [relobs, setarelobs]=React.useState('');
         //**************************** */
//**************************************obschecklist */

const [openobschecklist, setaopenobschecklist] = React.useState(false);
const [obschecklist, setaobschecklist] = React.useState([]);

const handleClickopendobschecklist = () => {
  var db3 = firebase.firestore();
 var query =  db3.collection("agenda").doc(props.props[0].id).collection("obschecklist").get()
 .then(function(querySnapshot) {
   setaobschecklist([])
   querySnapshot.forEach(function(doc) {
     var listaocorrencias=[];
      
     listaocorrencias.push({nomeassina:doc.data().nomeassina, obs: doc.data().obs, datahora:doc.data().datahora})
               
     console.log(listaocorrencias)
     setaobschecklist (currentArray => [...currentArray, listaocorrencias]);
 
})
setaopenobschecklist(true);

})





.catch(error => {
  console.log(error);
});

  
};

const handleClosedopenobschecklist = () => {
 setaopenobschecklist(false);
};


//************************* */
 //********************controle dialog desvio************ */
 const [ndesvios, setandesvios] = React.useState(0);

 const monitordesvio=()=>{
    
  var db2 = firebase.firestore();
        db2.collection("agenda").doc(props.props[0].id).collection("desvios")
        .onSnapshot((querySnapshot) => {
         
          
          var countrecados= 0
         

          querySnapshot.forEach((doc) => {
            
              countrecados=countrecados+1;
              
            
            });
            /*if(countrecados>0){
              alert("Você tem "+countrecados+" Novo(s) Recado(s)");
            }*/
            setandesvios(countrecados);

           
      })
      
        
 }
 const [opendesvio, setaopendesvio] = React.useState(false);
 
 const handleClickopendesvio = () => {
  setaopendesvio(true);
 };

 const handleCloseddesvio = () => {
  setaopendesvio(false);
 };



//***********************************desvios */

   //**************************** */
   const [listadesvio, setalisradesvio] = React.useState([]);
   const handledesvios=()=>{
    var listalocais=[];
    
    var db = firebase.firestore();
    console.log(props.props[0].id);
    console.log(props.props[0].id);
       var query =db.collection("agenda").doc(props.props[0].id).collection("desvios").get()
       .then(function(querySnapshot) {
        
        listalocais=[];
        querySnapshot.forEach(function(doc) {
          
  
           
           listalocais.push({title:"doc.data().datahora",  position:{lat:doc.data().lat, lng: doc.data().lng} });
  
                    
        }) 
  
         if(listalocais.length>0){
        setalisradesvio(listalocais);
       handleClickopendesvio();
         }else{
           alert("Não encontramos desvios neste deslocamento.")
         }
       
        
             
      })
     .catch(error => {
         console.log('Não encontramos motoristas cadastrados', error);
         alert("'Não encontramos desvios'");
     });
  
   }
         //************************************************ */

  const [opendespesas, setaopendespesas] = React.useState(false);

  const handleClickopendespesas = () => {
    setaopendespesas(true);
  };

  const handleClosedopendespesas = () => {
    setaopendespesas(false);
  };

  //**************************** */0.0
  const [stvalortotalfaturado, setavalortotalfaturado] = React.useState(0.0);
  const [stvalortotalpago, setavalortotalpago] = React.useState(0.0);
  const [sthora50, setahora50] = React.useState(0.0);
  const [sthora50pago, setahora50pago] = React.useState(0.0);
  const [sthora50faturado, setahora50faturado] = React.useState(0.0);
  const [stminuto50, setaminuto50] = React.useState(0.0);
  const [sthora100, setahora100] = React.useState(0.0);
  const [sthora100pago, setahora100pago] = React.useState(0.0);
  const [sthora100faturado, setahora100faturado] = React.useState(0.0);
  const [stminuto100, setastminuto100] = React.useState(0.0);
  const [stadicionalnhora, setaadicionalnhora] = React.useState(0.0);
  const [stadicionalnminuto, setastadicionalnminuto] = React.useState(0.0);
  const [stadicionalnhorapago, setastadicionalnhorapago] = React.useState(0.0);
  const [stadicionalnfaturado, setastadicionalnhorafaturado] = React.useState(0.0);
  const [stsobreavisohora, setasobreavisohora] = React.useState(0.0);
  const [stsobreavisominuto, setastsobreavisominuto] = React.useState(0.0);
  const [stsobreavisohorapago, setastsobreavisohorapago] = React.useState(0.0);
  const [stsobreavisohorafaturado, setastsobreavisohorafaturado] = React.useState(0.0);
  const [stesperahora, setaesperahora] = React.useState(0.0);
  const [stesperaminuto, setastesperaminuto] = React.useState(0.0);
  const [stesperahorapago, setastesperahorapago] = React.useState(0.0);
  const [stesperahorafaturado, setastesperahorafaturado] = React.useState(0.0);
  const [stcafe, setacafe] = React.useState(0.0);
  const [stcafepago, setastcafepago] = React.useState(0.0);
  const [stcafefaturado, setastcafefaturado] = React.useState(0.0);
  const [stalmoco, setaalmoco] = React.useState(0.0);
  const [stalmocopago, setastalmocopago] = React.useState(0.0);
  const [stalmocofaturado, setastalmocofaturado] = React.useState(0.0);
  const [stjanta, setajanta] = React.useState(0.0);
  const [stjantapago, setastjantapago] = React.useState(0.0);
  const [stjantafaturado, setastjantafaturado] = React.useState(0.0);
  const [stbanho, setabanho] = React.useState(0.0);
  const [stbanhopago, setastbanhopago] = React.useState(0.0);
  const [stbanhofaturado, setastbanhofaturado] = React.useState(0.0);
  const [stpernoite, setapernoite] = React.useState(0.0);
  const [stpernoitepago, setastpernoitepago] = React.useState(0.0);
  const [stpernoitefaturado, setastpernoitefaturado] = React.useState(0.0);



     

     //**************************** */
     const[stmarcacao, setamarcacao]=React.useState([]);
     const [openmarcacao, setaopenmarcacao] = React.useState(false);

     const handleClickopenmarcacao = () => {
      var db3 = firebase.firestore();
     var query =  db3.collection("agenda").doc(props.props[0].id).collection("marcacoes").orderBy('datahora').get()
     .then(function(querySnapshot) {
      setamarcacao([])
       querySnapshot.forEach(function(doc) {
         var listaocorrencias=[];
          
         listaocorrencias.push({marcacao: doc.data().marcacao, datahora:doc.data().datahora})
                   
         console.log(listaocorrencias)
         setamarcacao (currentArray => [...currentArray, listaocorrencias]);
     
   })
   setaopenmarcacao(true);
   
   })
   
   
   
   
   
   .catch(error => {
      console.log(error);
   });
   
      
    };
   
    const handleClosedopenmarcacao = () => {
      setaopenmarcacao(false);
    };
   
   //******************************** */
     //**************************** */


     //**************************** */
     const[stocorrencia, setaocorrencia]=React.useState([]);
     const [openocorrencia, setaopenocorrencia] = React.useState(false);

     const handleClickopenocorrencia = () => {
      var db3 = firebase.firestore();
     var query =  db3.collection("agenda").doc(props.props[0].id).collection("ocorrencias").get()
     .then(function(querySnapshot) {
       setaocorrencia([])
       querySnapshot.forEach(function(doc) {
         var listaocorrencias=[];
          
         listaocorrencias.push({nomeassina:doc.data().nomeassina, ocorrencia: doc.data().ocorrencia, datahora:doc.data().datahora})
                   
         console.log(listaocorrencias)
         setaocorrencia (currentArray => [...currentArray, listaocorrencias]);
     
   })
   setaopenocorrencia(true);
   
   })
   
   
   
   
   
   .catch(error => {
      console.log(error);
   });
   
      
    };
   
    const handleClosedopenocorrencia = () => {
      setaopenocorrencia(false);
    };
   
   //******************************** */
   const [openitinerariomapa, setaopenitinerariomapa] = React.useState(false);
 
 const handleClickopenitinerariomapa
  = () => {
  setaopenitinerariomapa(true);
 };

 const handleCloseditinerariomapa = () => {
  setaopenitinerariomapa(false);
 };

     //**************************** */

     
      
  return (
    <Card className={classes.root} >
           <CardHeader
             avatar={
               
               <Avatar aria-label="Veículo" className={classes.avatar}>
                <DriveEtaIcon />
               </Avatar>
             }
            
             title= {nsolicitacao}
             subheader= {dsolicitacao}
             action={
              <Tooltip title={"Itinerário"}>
              <IconButton
         className={classes.rounded3}
         onClick={handleClickopenitinerariomapa}
         //disabled={stbtsalvarveiculo}
         //aria-expanded={expanded}
         aria-label="Visualizar documento"
        
       >
         <ExploreIcon />
         
        
       </IconButton>
       </Tooltip>
             }

           />
           <CardContent>

           <Dialog open={openmarcacao} variant="outlined" onClose={handleClosedopenmarcacao} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Marcações</DialogTitle>
        <DialogContent>
          <DialogContentText>
         
          {stmarcacao.map(item=>(
           console.log(item[0]),
           <Typography variant="body2" color="textSecondary" component="p">
           Marcação: {item[0].marcacao}
          <br></br>
        Data: {new Date(item[0].datahora.seconds*1000).toLocaleString("pt-BR")}
        <br></br>
        <br></br>
       </Typography>
       
         ))}     
                 

         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
           
                      
          <Button variant="contained" onClick={handleClosedopenmarcacao} color="primary" >
            Ok
          </Button>
          </DialogActions>
      </Dialog>




           <Dialog open={openocorrencia} variant="outlined" onClose={handleClosedopenocorrencia} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Ocorrências</DialogTitle>
        <DialogContent>
          <DialogContentText>
         
          {stocorrencia.map(item=>(
           console.log(item[0]),
           <Typography variant="body2" color="textSecondary" component="p">
           Nome: {item[0].nomeassina}
         <br></br>
         Ocorrência: {item[0].ocorrencia}
         <br></br>
        Data: {new Date(item[0].datahora.seconds*1000).toLocaleString("pt-BR")}
        <br></br>
        <br></br>
       </Typography>
       
         ))}     
                 

         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
            
                      
          <Button variant="contained" onClick={handleClosedopenocorrencia} color="primary" >
            Ok
          </Button>
          </DialogActions>
      </Dialog>

      <Dialog fullScreen open={opendesvio} variant="outlined" onClose={handleCloseddesvio} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Localização</DialogTitle>
        <DialogContent>
          <DialogContentText>
         <div>
          <Localizadesvio list={listadesvio}/>
          </div>
         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
            
           
          <Button variant="contained" onClick={handleCloseddesvio} color="primary" >
            OK
          </Button>
          </DialogActions>
      </Dialog>


           <Dialog open={opendchecklist} variant="outlined" onClose={handleClosedopendchecklist} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">CheckList</DialogTitle>
        <DialogContent>
          <DialogContentText>
         
          <FormControl component="fieldset">
              <FormLabel component="legend">Motor: óleo do motor; níveis de água do radiador; fluído de freio; fluído de embreagem; fluído de direção.</FormLabel>
      <RadioGroup aria-label="gender" name="gender1" value={stmotoretc} onChange={handlemotoretc}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>
    

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelmotor(e.target.value)}
          type=""
          fullWidth
          id="motor"
          label="Descrição - Relato"
          name="observacao"  
          value={relmotor}    
         
          />
          <br></br>
          <br></br>

        <FormControl component="fieldset">
              <FormLabel component="legend">Estado dos pneus; calibragem.</FormLabel>
      <RadioGroup aria-label="gender" name="gender2" value={stpneu} onChange={handlepneu}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelpneu(e.target.value)}
          type=""
          fullWidth
          id="pneu"
          label="Descrição - Relato"
          name="observacao"  
          value={relpneu}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Sinalização (faróis, lanternas, piscas).</FormLabel>
      <RadioGroup aria-label="gender" name="gender3" value={stsinal} onChange={handlesinal}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelmacaco(e.target.value)}
          type=""
          fullWidth
          id="sinal"
          label="Descrição - Relato"
          name="observacao"  
          value={relsinal}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Macaco; estepe; triângulo; chave de roda.</FormLabel>
      <RadioGroup aria-label="gender" name="gender5" value={stmacaco} onChange={handlemacaco}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelmacaco(e.target.value)}
          type=""
          fullWidth
          id="macaco"
          label="Descrição - Relato"
          name="observacao"  
          value={relmacaco}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Ar-condicionado.</FormLabel>
      <RadioGroup aria-label="gender" name="gender6" value={star} onChange={handlear}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelar(e.target.value)}
          type=""
          fullWidth
          id="ar"
          label="Descrição - Relato"
          name="observacao"  
          value={relar}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Extintor.</FormLabel>
      <RadioGroup aria-label="gender" name="gender7" value={stextintor} onChange={handleextintor}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelextintor(e.target.value)}
          type=""
          fullWidth
          id="extintor"
          label="Descrição - Relato"
          name="observacao"  
          value={relextintor}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Cinto de segurança; buzina; espelhos retrovisores.</FormLabel>
      <RadioGroup aria-label="gender" name="gender8" value={stcinto} onChange={handlecinto}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelcinto(e.target.value)}
          type=""
          fullWidth
          id="cinto"
          label="Descrição - Relato"
          name="observacao"  
          value={relcinto}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Tacógrafo; velocímetro.</FormLabel>
      <RadioGroup aria-label="gender" name="gender9" value={stvel} onChange={handlevel}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelvel(e.target.value)}
          type=""
          fullWidth
          id="vel"
          label="Descrição - Relato"
          name="observacao"  
          value={relvel}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Laudo LIT-ANTT (coletivos).</FormLabel>
      <RadioGroup aria-label="gender" name="gender10" value={stlaudo} onChange={handlelaudo}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="V" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="F" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarellaudo(e.target.value)}
          type=""
          fullWidth
          id="laudo"
          label="Descrição - Relato"
          name="observacao"  
          value={rellaudo}    
         
          />
          <br></br>
          <br></br>

          <FormControl component="fieldset">
              <FormLabel component="legend">Limpeza do veículo </FormLabel>
      <RadioGroup aria-label="gender" name="gender11" value={stlimpa} onChange={handlelimpa}>
        <Grid container>
        <Grid item>
        <FormControlLabel value="1" control={<Radio />} label="Boa" />
        </Grid>
        <Grid item>
        <FormControlLabel value="2" control={<Radio />} label="Ruim" />
        </Grid>

        </Grid>
            
         
        </RadioGroup>
    </FormControl>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarellimpa(e.target.value)}
          type=""
          fullWidth
          id="limpa"
          label="Descrição - Relato"
          name="observacao"  
          value={rellimpa}  
          
         
          />
          <br></br>
          <br></br>

          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setarelobs(e.target.value)}
          type=""
          fullWidth
          id="obs"
          label="Observações"
          name="observacao"  
          value={relobs}    
          multiline
          rows={4}  
          />
          <br></br>
          <br></br>

          

         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClosedopendchecklist} color="primary" >
            OK
          </Button>
          </DialogActions>
      </Dialog>


      <Dialog open={opendespesas} variant="outlined" onClose={handleClickopendespesas} aria-labelledby="form-dialog-title" >
          <DialogTitle id="form-dialog-naodep">Horas Extras e Diárias</DialogTitle>
          <DialogContent>
            <DialogContentText>

              <Typography variant="body2" color="textSecondary" component="p">
                Valores Totais


              </Typography>

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setavalortotalpago(e.target.value)}
                type="Float"

                id="valortotal"

                label="Valor Total Pago ao Motorista"
                name="observacao"
                value={stvalortotalpago}
                disabled={true}
              />

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setavalortotalfaturado(e.target.value)}
                type="Float"
                label="Valor Total Faturado R$"
                id="valortotal"
                label="Valor Total Faturado"
                name="observacao"
                value={stvalortotalfaturado}
                disabled={true}
              />



              <Typography variant="body2" color="textSecondary" component="p">
                Hora extra 50%
              </Typography>
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setahora50(e.target.value)}
                type=""

                id="hora50"
                label="Horas"
                name="observacao"
                value={sthora50}

              />

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setaminuto50(e.target.value)}
                type=""

                id="hora50"
                label="Minutos"
                name="observacao"
                value={stminuto50}

              />

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setahora50pago(e.target.value)}
                type=""
                disabled={true}
                id="hora50"
                label="Valor Pago ao Motorista R$"
                name="observacao"
                value={sthora50pago}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setahora50faturado(e.target.value)}
                type=""

                id="hora50"
                label="Valor Faturado R$"
                name="observacao"
                value={sthora50faturado}

              />

              <Typography variant="body2" color="textSecondary" component="p">
                Hora extra 100%
              </Typography>
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setahora100(e.target.value)}
                type=""

                id="hora100"
                label="Horas"
                name="observacao"
                value={sthora100}

              />

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setastminuto100(e.target.value)}
                type=""

                id="hora50"
                label="Minutos"
                name="observacao"
                value={stminuto100}

              />

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setahora100pago(e.target.value)}
                type=""
                disabled={true}
                id="hora50"
                label="Valor Pago ao Motorista R$"
                name="observacao"
                value={sthora100pago}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setahora100faturado(e.target.value)}
                type=""
                disabled={true}
                id="hora50"
                label="Valor Faturado R$"
                name="observacao"
                value={sthora100faturado}

              />

              <Typography variant="body2" color="textSecondary" component="p">
                Hora adicional noturno
              </Typography>
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setaadicionalnhora(e.target.value)}
                type=""

                id="adicional"
                label="Horas"
                name="observacao"
                value={stadicionalnhora}

              />

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setastadicionalnminuto(e.target.value)}
                type=""

                id="hora50"
                label="Minutos"
                name="observacao"
                value={stadicionalnminuto}

              />

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setastadicionalnhorapago(e.target.value)}
                type=""
                disabled={true}
                id="hora50"
                label="Valor Pago ao Motorista R$"
                name="observacao"
                value={stadicionalnhorapago}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setastadicionalnhorafaturado(e.target.value)}
                type=""
                disabled={true}
                id="hora50"
                label="Valor Faturado R$"
                name="observacao"
                value={stadicionalnfaturado}

              />

              <Typography variant="body2" color="textSecondary" component="p">
                Hora Sobre-aviso
              </Typography>
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setasobreavisohora(e.target.value)}
                type=""

                id="sobreaviso"
                label="Horas"
                name="observacao"
                value={stsobreavisohora}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setastsobreavisominuto(e.target.value)}
                type=""

                id="hora50"
                label="Minutos"
                name="observacao"
                value={stsobreavisominuto}

              />

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setastsobreavisohorapago(e.target.value)}
                type=""
                disabled={true}
                id="hora50"
                label="Valor Pago ao Motorista R$"
                name="observacao"
                value={stsobreavisohorapago}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setastsobreavisohorafaturado(e.target.value)}
                type=""

                id="hora50"
                label="Valor Faturado R$"
                name="observacao"
                value={stsobreavisohorafaturado}

              />

              <Typography variant="body2" color="textSecondary" component="p">
                Hora Espera
              </Typography>


              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setaesperahora(e.target.value)}
                type=""

                id="espera"
                label="Horas"
                name="observacao"
                value={stesperahora}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setastesperaminuto(e.target.value)}
                type=""

                id="hora50"
                label="Minutos"
                name="observacao"
                value={stesperaminuto}

              />

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setastesperahorapago(e.target.value)}
                type=""
                disabled={true}
                id="hora50"
                label="Valor Pago ao Motorista R$"
                name="observacao"
                value={stesperahorapago}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setastesperahorafaturado(e.target.value)}
                type=""
                disabled={true}
                id="hora50"
                label="Valor Faturado R$"
                name="observacao"
                value={stesperahorafaturado}

              />

              <Typography variant="body2" color="textSecondary" component="p">
                Café
              </Typography>

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setacafe(e.target.value)}
                type=""

                id="cafe"
                label="Quantidade"
                name="observacao"
                value={stcafe}

              />
              <br></br>

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setastcafepago(e.target.value)}
                type=""

                id="hora50"
                label="Valor Pago ao Motorista R$"
                name="observacao"
                value={stcafepago}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setastcafefaturado(e.target.value)}
                type=""

                id="hora50"
                label="Valor Faturado R$"
                name="observacao"
                value={stcafefaturado}

              />

              <Typography variant="body2" color="textSecondary" component="p">
                Almoço
              </Typography>

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setaalmoco(e.target.value)}
                type=""

                id="almoco"
                label="Quantidade"
                name="observacao"
                value={stalmoco}

              />
              <br></br>
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setastalmocopago(e.target.value)}
                type=""

                id="hora50"
                label="Valor Pago ao Motorista R$"
                name="observacao"
                value={stalmocopago}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setastalmocofaturado(e.target.value)}
                type=""

                id="hora50"
                label="Valor Faturado R$"
                name="observacao"
                value={stalmocofaturado}

              />

              <Typography variant="body2" color="textSecondary" component="p">
                Jantar
              </Typography>

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setajanta(e.target.value)}
                type=""

                id="janta"
                label="Janta"
                name="observacao"
                value={stjanta}

              />
              <br></br>
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setastjantapago(e.target.value)}
                type=""

                id="hora50"
                label="Valor Pago ao Motorista R$"
                name="observacao"
                value={stjantapago}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setastjantafaturado(e.target.value)}
                type=""

                id="hora50"
                label="Valor Faturado R$"
                name="observacao"
                value={stjantafaturado}

              />

              <Typography variant="body2" color="textSecondary" component="p">
                Banho
              </Typography>

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setabanho(e.target.value)}
                type=""

                id="banho"
                label="Quantidade"
                name="observacao"
                value={stbanho}

              />
              <br></br>
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setastbanhopago(e.target.value)}
                type=""

                id="hora50"
                label="Valor Pago ao Motorista R$"
                name="observacao"
                value={stbanhopago}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setastbanhofaturado(e.target.value)}
                type=""

                id="hora50"
                label="Valor Faturado R$"
                name="observacao"
                value={stbanhofaturado}

              />

              <Typography variant="body2" color="textSecondary" component="p">
                Pernoite
              </Typography>

              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"

                onChange={e => setapernoite(e.target.value)}
                type=""

                id="pernoite"
                label="Quantidade"
                name="observacao"
                value={stpernoite}


              />
              <br></br>
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setastpernoitepago(e.target.value)}
                type=""

                id="hora50"
                label="Valor Pago ao Motorista R$"
                name="observacao"
                value={stpernoitepago}

              />
              <TextField
                variant="outlined"
                margin="normal" aria-label="minimum height"
                disabled={true}
                onChange={e => setastpernoitefaturado(e.target.value)}
                type=""

                id="hora50"
                label="Valor Faturado R$"
                name="observacao"
                value={stpernoitefaturado}

              />


            </DialogContentText>

          </DialogContent>
          <DialogActions>
            
            <Button variant="contained" onClick={handleClosedopendespesas} color="primary" >
              OK
            </Button>
          </DialogActions>
        </Dialog>

           
           
           
                <Typography variant="body2" color="textSecondary" component="p">
               {campisolicitante}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               {depsolicitente}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Nome Solicitante: {nomesolicitante}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               {tipodeslocamento}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Objetivo: {objetivo}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Quilometragem: {kilometragem}
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
               Veículo: {verveiculo}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Motorista: {vermotorista}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Previsão de custo de rodagem R${valorkm}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Total Pago R$ {stvalortotalfaturado}
             </Typography>

                         
             <TextField
            className={classes.datas}
         id="datetimeini2"
        label="Data e hora da Saída"
        disabled={true}
        value={datahorasaida}
        />
         <TextField
             className={classes.datas}
             id="datetimeini"
            label="Data e hora do Retorno"
            disabled={true}
            
            value={datahoraretorno}
            />
            
             
             
            <Dialog  open={openitinerariomapa} variant="outlined" onClose={handleCloseditinerariomapa} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Itinerário</DialogTitle>
        <DialogContent>
          <DialogContentText>
        
         <Mapdialog   props={stid}/>
          
         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
            
           
          <Button variant="contained" onClick={handleCloseditinerariomapa} color="primary" >
            OK
          </Button>
          </DialogActions>
      </Dialog>


           </CardContent>

          
            <CardActions disableSpacing>
                <div  hidden={stbotoes}>

                <Tooltip title={"CheckList"}>
           <IconButton
      //disabled={stbtdeferi}
     // className={classes.rounded}
      onClick={handleClickopendchecklist}
      aria-expanded={expanded}
      aria-label="checklist"
      
    >
      <AssignmentTurnedInIcon />
    </IconButton>
    </Tooltip>

    <Tooltip title={"Obs. CheckList"}>
           <IconButton
      //disabled={stbtdeferi}
     // className={classes.rounded}
      onClick={handleClickopendobschecklist}
      aria-expanded={expanded}
      aria-label="checklist"
      
    >
      <ReportIcon />
    </IconButton>
    </Tooltip>


    <Tooltip title={"Marcações"}>
           <IconButton
      //disabled={stbtdeferi}
     // className={classes.rounded}
      onClick={handleClickopenmarcacao}
      aria-expanded={expanded}
      aria-label="checklist"
      
    >
      <AccessTimeIcon />
    </IconButton>
    </Tooltip>

    <Tooltip title={"Desvios"}>
           <IconButton
     // className={classes.rounded}
      onClick={handledesvios}
      //disabled={stbtsalvartranferencia}
      //aria-expanded={expanded}
      aria-label="localizar"
     
    >
      <Badge badgeContent={ndesvios} color="secondary" >
      <CallSplitIcon />
      </Badge>
    </IconButton>
    </Tooltip>
    

    <Tooltip title={"Ocorrências"}>
           <IconButton
      //disabled={stbtdeferi}
     // className={classes.rounded}
      onClick={handleClickopenocorrencia}
      aria-expanded={expanded}
      aria-label="checklist"
      
    >
      <ReportProblemIcon />
    </IconButton>
    </Tooltip>
    

    <Tooltip title={"Custos"}>
    <IconButton
     // className={classes.rounded}
      //disabled={stbtindeferi}
      onClick={handleClickopendespesas}
      //aria-expanded={expanded}
      aria-label="planilha de custos"
      
    >
      <MonetizationOnIcon />
    </IconButton>
  </Tooltip>

  <Tooltip title={"Diário de bordo"}>
           <IconButton
      className={classes.rounded3}
      onClick={visualizardiario}
      //disabled={stbtsalvarveiculo}
      //aria-expanded={expanded}
      aria-label="Visualizar documento"
     
    >
      <AssignmentIcon />
     
    </IconButton>
    </Tooltip>
    
    <Tooltip title={"Ordem de Trânsito"}>
           <IconButton
      className={classes.rounded3}
      onClick={visualizarordem}
      //disabled={stbtsalvarveiculo}
      //aria-expanded={expanded}
      aria-label="Visualizar documento"
     
    >
      <ListAltIcon />
     
    </IconButton>
    </Tooltip>
    <Tooltip title={"Solicitação de Transporte"}>
           <IconButton
      className={classes.rounded3}
      onClick={visualizarsolicitacao}
      //disabled={stbtsalvarveiculo}
      //aria-expanded={expanded}
      aria-label="Visualizar documento"
     
    >
      <AssignmentIcon />
     
    </IconButton>
    </Tooltip>


 

    




    

           
            
     
             </div>
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
           </CardActions>
           <Collapse in={expanded} timeout="auto" unmountOnExit>
             <CardContent>
             <Typography variant="body2" color="textSecondary" component="p">
              Saída: {localsaida}
               
               
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Destino: {localdestino}
               
               
             </Typography>

              <div hidden={stdivdespesas}>
                

               <Typography variant="body2" color="textSecondary" component="p">
               Responsável pelas Despesas: {nomerespdespesas}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Telefone Responsável pelas Despesas: {fonerespdespesas}
             </Typography>
               </div>

              
                       <br></br>    


             <Typography variant="body2" color="textSecondary" component="p">
               Nº Passageiros: {npassageiro}
               <br></br>
               {passageiros}
               
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
               Observações: {observacao}
             </Typography>
             
              { anexo.map(item=>(
                <Typography variant="body2" color="textSecondary" component="p">
                  Anexo:
                  <br></br>
                <Link  href={item.link} target="_blank" rel="noopener">{item.nome}</Link>
                </Typography>
              ))

              }
               
             <Typography variant="body2" color="textSecondary" component="p">
               Autorizações: 

               </Typography>
                 
                 
               {autorizacoes.map(item=>(
                <Typography variant="body2" color="textSecondary" component="p">
                Nome: {item.nomeassina}
                <br></br>
                Siape: {item.siapeassina}
                <br></br>
                {item.acao}
                <br></br>
              </Typography>
                 
              ))}
             
            
              
     
             </CardContent>
             <CardActions disableSpacing>
           
                
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
             
     
           </CardActions>
           </Collapse>
         </Card>

         
  );
}
